import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const ActionRequiredIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1.5C2.27614 1.5 2.5 1.72386 2.5 2V2.35961L3.72546 2.05325C5.23075 1.67692 6.82101 1.85149 8.20883 2.5454L8.28064 2.5813C9.43146 3.15671 10.7476 3.31044 12 3.01575L14.0731 2.52797C14.231 2.49081 14.3972 2.53259 14.5187 2.64003C14.6403 2.74747 14.7022 2.90722 14.6847 3.06852C14.5626 4.19542 14.5 5.3403 14.5 6.5C14.5 7.66936 14.5637 8.82367 14.6878 9.95966C14.7152 10.2107 14.5511 10.4428 14.3052 10.5007L12.2291 10.9892C10.7489 11.3374 9.19349 11.1558 7.83343 10.4757L7.76162 10.4398C6.58731 9.85267 5.24171 9.70496 3.96799 10.0234L2.5 10.3904V14C2.5 14.2761 2.27614 14.5 2 14.5C1.72386 14.5 1.5 14.2761 1.5 14V2C1.5 1.72386 1.72386 1.5 2 1.5Z"
      fill="currentColor"
    />
  </svg>
);

export default ActionRequiredIcon;
